import { useDeviceSize } from '@libs/utils/hooks/useDeviceSize';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTracking } from '@common/hooks/useTracking';
import { RouteMap } from '@common/constants/RouteMap';
import classNames from 'classnames';

import { Text, Conditional } from '@consumidor-positivo/aurora';

import useRenegAppExperiment from '@common/abtest/experiments/useRenegAppExperiment';
import { DataNavButtons } from './data';
import './styles.scss';

type NavButton = {
  label: string;
  path: string;
  icon: JSX.Element;
};

type AppNavigationProps = {
  buttons?: NavButton[];
  hasNotifier?: boolean;
  hasNotifierLabel?: 'Score' | 'Crédito' | 'Dívidas';
};

export const AppNavigation = ({ buttons = DataNavButtons(), hasNotifier = false, hasNotifierLabel }: AppNavigationProps) => {
  const { elementClickedEvent } = useTracking();
  const { isDesktop } = useDeviceSize();
  const location = useLocation();
  const navigate = useNavigate();
  const { getRedirectUrl } = useRenegAppExperiment();

  const paths = buttons.map(({ path }) => path) as string[];

  const handleAppNavigationClick = (path: string) => {
    const indexMap: Record<string, string> = {
      [RouteMap.MyScore]: 'score',
      [RouteMap.MyOffers]: 'credito',
      [RouteMap.MyCpf]: 'dividas',
      [RouteMap.MyDebtsAC]: 'dividas-ac',
    };

    const name = indexMap[path];

    elementClickedEvent({
      elementType: 'content',
      location: '/home',
      position: 'dashboard-tab',
      name: name,
    });

    if (path === RouteMap.MyDebtsAC) {
      window.location.href = getRedirectUrl('debts');
      return;
    }

    navigate(path);
  };

  if (!paths.includes(location.pathname) || isDesktop) {
    return null;
  }

  return (
    <div className="app-navigation">
      <nav className="app-navigation__nav">
        {buttons.map(({ label, path, icon }) => {
          const isActive = location.pathname === path;
          const shouldShowNotifier = hasNotifier && hasNotifierLabel === label;

          return (
            <div
              key={path}
              className={classNames('app-navigation__action', {
                'app-navigation__action--active': isActive,
              })}
              onClick={() => handleAppNavigationClick(path)}
            >
              <div
                className={classNames('app-navigation__indicator', {
                  'app-navigation__indicator--active': isActive,
                })}
              />
              <div className="app-navigation__icon-wrapper">
                {icon}
                <Conditional condition={shouldShowNotifier} renderIf={<div className="app-navigation__notification-dot" />} />
              </div>
              <Text as="p" variant="caption">
                {label}
              </Text>
            </div>
          );
        })}
      </nav>
    </div>
  );
};
